import AnalyticNew from "./AnalyticNew";
import { ClientStockProvider } from "./context/ClientStockContext";

export default function AnalyticsNewWrapper(props) {
 return(
  <ClientStockProvider>
    <AnalyticNew {...props} />
  </ClientStockProvider>
 )
}
